module.exports = __webpack_public_path__ + "img/pgt_logo.309659c9.png";